import PropTypes from "prop-types";
import { Container } from "@mui/material";

import ProductMetaTags from "components/ProductMetaTags";
import { useScreen } from "hooks";
import EventDetails from "components/EventDetails";
import PreviewVideoPlayer from "components/PreviewVideoPlayer";
import TemplateGroupTitle from "components/TemplateGroupTitle";
import TemplateGroupDescription from "components/TemplateGroupDescription";
import TemplateGroupPresenter from "presenters/TemplateGroupPresenter";
import MainTitle from "components/MainTitle";
import { DEFAULT_INVITE_THEME } from "enums";

import Actions from "./components/Actions";
import StickyActions from "./components/StickyActions";
import { Content, Invite, Main, MainInfo, Root, VideoBorder } from "./styles";

const View = ({ loading, templateGroup }) => {
  const theme = TemplateGroupPresenter.theme(templateGroup) || DEFAULT_INVITE_THEME;
  const title = `${TemplateGroupPresenter.name(templateGroup)} Online Invitation`;
  const { isMobile } = useScreen();

  return (
    <Container>
      <Root>
        <MainInfo>
          <Invite>
            <VideoBorder inviteTheme={theme}>
              <PreviewVideoPlayer loading={loading} templateGroup={templateGroup} />
            </VideoBorder>
            <EventDetails theme={theme} />
          </Invite>
          <Main>
            <Content>
              <TemplateGroupTitle templateGroup={templateGroup} />
              <TemplateGroupDescription templateGroup={templateGroup} />
            </Content>
            {!isMobile && <Actions loading={loading} templateGroup={templateGroup} />}
          </Main>
          {isMobile && <StickyActions loading={loading} templateGroup={templateGroup} />}
        </MainInfo>
      </Root>

      <MainTitle title={title} />
      <ProductMetaTags product={templateGroup} presenter={TemplateGroupPresenter} />
    </Container>
  );
};

View.propTypes = {
  loading: PropTypes.bool,
  templateGroup: TemplateGroupPresenter.shape(),
};

export default View;
